import React from "react"
import Home from "#/components/views/home/Home"
import { ConsumerHomePage } from "#/pages/consumer/home/page"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

export function CarrotPlanRoute(): JSX.Element {
  const { data: programFlags, isLoading, isError } = useMemberProgramFlags()
  // Fail-safe: only branch when the program type is known. Treating an
  // errored query as non-consumer would silently show the enterprise Home
  // to a consumer member.
  if (isLoading || isError || !programFlags) return <PageLoading />
  return programFlags.isConsumer ? <ConsumerHomePage /> : <Home />
}
